<script lang="ts" setup>
import { onMounted } from 'vue';

import CategoryLabel from './components/CategoryLabel.vue';
import ProductCard from './components/ProductCard.vue';

import { useSettings } from './services/use.settings.js';
import { useStepperBlock } from '../services/use.stepper-block.js';
import { useSelectedCategory } from './services/use.selected-category.js';
import { useRemoteProducts } from '../services/use.remote-products.js';
import { useSelectedProducts } from '../services/use.selected-product.js';
import { useStore } from './services/use.store.js';

const { settings, refreshSettings } = useSettings();
const { toggleProduct, isProductSelected, selectedProducts } = useSelectedProducts();
const { loadProducts, products } = useRemoteProducts(() => {});
const { selectedCategory, selectCategory } = useSelectedCategory(loadProducts);

useStepperBlock('upsells', async () => true);
useStore(selectedProducts);

onMounted(() => {
  refreshSettings();
});
</script>

<template>
  <section class="upsells">
    <header class="upsells-categories">
      <category-label
        v-for="collection in settings?.collection_groups"
        :key="collection.slug"
        :is-active="selectedCategory === collection.label"
        :label="collection.label"
        @selected="() => selectCategory(collection.label, collection.products)"
      />
    </header>

    <div class="upsells-products-grid">
      <product-card
        v-for="product in products"
        class="product-config-upsell-card"
        :allow-multiple="true"
        :key="product.id"
        :input-name="'upsells'"
        :product="product"
        :is-active="isProductSelected(product)"
        @selected="() => toggleProduct(product)"
      />
    </div>
  </section>
</template>
